"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NativeFcmSendIntegrationConfigBuilder = void 0;
var abstract_builder_1 = require("./abstract-builder");
var native_fcm_send_integration_config_1 = require("../structs/send-integration-configurations/native-fcm-send-integration-config");
var NativeFcmSendIntegrationConfigBuilder = (function (_super) {
    __extends(NativeFcmSendIntegrationConfigBuilder, _super);
    function NativeFcmSendIntegrationConfigBuilder() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.Model = native_fcm_send_integration_config_1.NativeFcmSendIntegrationConfig;
        return _this;
    }
    Object.defineProperty(NativeFcmSendIntegrationConfigBuilder.prototype, "apiVersion", {
        get: function () {
            return this.data.apiVersion;
        },
        enumerable: false,
        configurable: true
    });
    NativeFcmSendIntegrationConfigBuilder.prototype.setApiVersion = function (apiVersion) {
        this.data.apiVersion = apiVersion;
        return this;
    };
    Object.defineProperty(NativeFcmSendIntegrationConfigBuilder.prototype, "isActive", {
        get: function () {
            return this.data.isActive;
        },
        enumerable: false,
        configurable: true
    });
    NativeFcmSendIntegrationConfigBuilder.prototype.setIsActive = function (isActive) {
        this.data.isActive = isActive;
        return this;
    };
    Object.defineProperty(NativeFcmSendIntegrationConfigBuilder.prototype, "senderId", {
        get: function () {
            return this.data.senderId;
        },
        enumerable: false,
        configurable: true
    });
    NativeFcmSendIntegrationConfigBuilder.prototype.setSenderId = function (senderId) {
        this.data.senderId = senderId;
        return this;
    };
    Object.defineProperty(NativeFcmSendIntegrationConfigBuilder.prototype, "serverApiKey", {
        get: function () {
            return this.data.serverApiKey;
        },
        enumerable: false,
        configurable: true
    });
    NativeFcmSendIntegrationConfigBuilder.prototype.setServerApiKey = function (serverApiKey) {
        this.data.serverApiKey = serverApiKey;
        return this;
    };
    Object.defineProperty(NativeFcmSendIntegrationConfigBuilder.prototype, "serviceAccountJsonFileUrl", {
        get: function () {
            return this.data.serviceAccountJsonFileUrl;
        },
        enumerable: false,
        configurable: true
    });
    NativeFcmSendIntegrationConfigBuilder.prototype.setServiceAccountJsonFileUrl = function (serviceAccountJsonFileUrl) {
        this.data.serviceAccountJsonFileUrl = serviceAccountJsonFileUrl;
        return this;
    };
    Object.defineProperty(NativeFcmSendIntegrationConfigBuilder.prototype, "notificationAccentColor", {
        get: function () {
            return this.data.notificationAccentColor;
        },
        enumerable: false,
        configurable: true
    });
    NativeFcmSendIntegrationConfigBuilder.prototype.setNotificationAccentColor = function (color) {
        this.data.notificationAccentColor = color;
        return this;
    };
    Object.defineProperty(NativeFcmSendIntegrationConfigBuilder.prototype, "useImageForIconWhenPresent", {
        get: function () {
            return this.data.useImageForIconWhenPresent;
        },
        enumerable: false,
        configurable: true
    });
    NativeFcmSendIntegrationConfigBuilder.prototype.setUseImageForIconWhenPresent = function (useImage) {
        this.data.useImageForIconWhenPresent = useImage;
        return this;
    };
    NativeFcmSendIntegrationConfigBuilder.prototype.build = function (options) {
        if (this.isActive) {
            options = __assign(__assign({}, options), { groups: this.apiVersion ? [this.apiVersion] : [] });
        }
        return _super.prototype.build.call(this, options);
    };
    return NativeFcmSendIntegrationConfigBuilder;
}(abstract_builder_1.AbstractBuilder));
exports.NativeFcmSendIntegrationConfigBuilder = NativeFcmSendIntegrationConfigBuilder;
//# sourceMappingURL=native-fcm-send-integration-config-builder.js.map